var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zh-loading-box"},[_c('div',{staticClass:"zh-loading-inner"},[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zh-loading"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }